import React from "react";
import styles from "./ModalContent.module.scss";
import StyledContainer from "./../../../partials/StyledContainer";
import Button from "../../../partials/Button";
import Scroll from "../../../partials/Scroll/Scroll";


const ModalContent = ({
  isRight,
  message,
  warningMessage,
  onNextStepClick,
  buttonText,
  media,
}) => {
  let color = isRight ? "#63C132" : "#A31621";
  return (
    <StyledContainer className={styles.container}>
      <div style={{ justifyContent: "center" }}>
        <div
          className={styles.messageContainer}
          style={{ borderColor: color, padding: "20px" }}
        >
          {/* As Discussed with Nickie made a Temporary Solution  */}
          {/* <div style={{ backgroundColor: color }}> */}
          <Scroll>
            <div className={styles.modal_scroll}>
              <div style={{ display: "contents", fontWeight: "initial", color: "white", lineHeight: "initial" }} dangerouslySetInnerHTML={{ __html: message }} />
              <div className={styles.warningMessage}>{warningMessage}</div>
            </div>
          </Scroll>
          <Button onClick={(e) => onNextStepClick()} text={buttonText} />
        </div>
      </div>
      <div style={{ alignItems: "center" }}>{media}</div>
    </StyledContainer >
  );
};

export default ModalContent;
